<template>
  <a
    :class="{active}"
    :href="path"
    class="menu-item"
    @click.p.prevent="onClick">
    Verify Token
  </a>
</template>

<script>
export default {
  data() {
    return {
      path: '/verify-token'
    };
  },
  computed: {
    active() {
      return this.path === this.$store.path;
    }
  },
  methods: {
    onClick() {
      this.$store.navigate(this.path, {});
    }
  }
};
</script>
